"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _clsx = _interopRequireDefault(require("clsx"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _AppStore = _interopRequireDefault(require("../Store/AppStore"));

var _reactRouterDom = require("react-router-dom");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * File: PaymentMethodPage.js
 * Project: tsys-online-payments
 *
 * Created by Jed Dumire on 08/05/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Payment method selection page.
 * If no wallets are available, or if user clicks on the "Use a different card button", TSEP fields will be shown.
 */
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: 550,
      padding: theme.spacing(2)
    },
    radio: {
      paddingRight: theme.spacing(3)
    },
    singlePadding: {
      padding: theme.spacing(1)
    },
    selectedCard: {
      backgroundColor: theme.palette.primary.light,
      borderColor: theme.palette.primary.main
    },
    fullWidth: {
      width: "100%"
    },
    halfWidth: {
      width: "50%"
    },
    buttonPadding: {
      padding: theme.spacing(1, 0)
    }
  };
});

var PaymentMethodPage = function PaymentMethodPage() {
  var classes = useStyles();
  var history = (0, _reactRouterDom.useHistory)();

  var walletsDisplay = function walletsDisplay() {
    return /*#__PURE__*/_react.default.createElement(_core.RadioGroup, {
      value: _AppStore.default.selectedWallet.walletId,
      onChange: function onChange(e) {
        return _AppStore.default.selectWallet(e.target.value);
      }
    }, _AppStore.default.wallets.map(function (wallet, idx) {
      return /*#__PURE__*/_react.default.createElement(_core.Card, {
        variant: "outlined",
        key: idx,
        raised: true,
        className: (0, _clsx.default)(classes.singlePadding, _AppStore.default.selectedWallet.walletId === wallet.walletId && classes.selectedCard)
      }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
        className: (0, _clsx.default)(classes.fullWidth, classes.singlePadding),
        value: wallet.walletId,
        control: /*#__PURE__*/_react.default.createElement(_core.Radio, {
          color: "primary",
          className: classes.radio
        }),
        label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
          variant: "h6",
          align: "left"
        }, /*#__PURE__*/_react.default.createElement("b", null, wallet.displayName)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
          align: "left",
          gutterBottom: true
        }, wallet.accountName), /*#__PURE__*/_react.default.createElement(_core.Typography, {
          variant: "body2",
          align: "left",
          color: "textSecondary"
        }, "Expires ", wallet.expiration))
      }));
    }));
  };

  if (_AppStore.default.loadingWallets) {
    return /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null);
  }

  if (!_AppStore.default.selectedAccount || !_AppStore.default.paymentAmount) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: "/accountSelect"
    });
  }

  if (!_AppStore.default.wallets || _AppStore.default.wallets.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: "/cardEntry"
    });
  }

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, walletsDisplay()), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    spacing: 1,
    className: classes.buttonPadding
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.halfWidth
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "outlined",
    color: "primary",
    startIcon: /*#__PURE__*/_react.default.createElement(_ArrowBack.default, null),
    className: classes.fullWidth,
    onClick: function onClick() {
      return history.goBack();
    }
  }, "Go Back")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    className: classes.halfWidth
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "outlined",
    color: "primary",
    className: classes.fullWidth,
    component: _reactRouterDom.Link,
    to: "/cardEntry"
  }, "Use A Different Card"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    className: classes.fullWidth,
    to: "/summary",
    component: _reactRouterDom.Link
  }, "Next")));
};

var _default = (0, _mobxReact.observer)(PaymentMethodPage);

exports.default = _default;